export const COMPANY = {
  name: "R-Tech Computer",
  tagline: "Your Trusted IT Support Partner",
  phone: "+91 84118 86483",
  phoneRaw: "918411886483",
  email: "Rtechcomputer0104@gmail.com",
  address: "Andheri East, Mahakali Road, Opposite Atul Compound, Mumbai, India – 400093",
  shortAddress: "Andheri East, Mumbai – 400093",
  whatsappMessage: "Hello R-Tech Computer, I'd like to know more about your IT services.",
  logo: "https://customer-assets.emergentagent.com/job_455d6a29-d86a-426b-b596-2587461c39c1/artifacts/qywp9qw2_Untitled-1.jpg",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Careers", path: "/careers" },
  { label: "Contact", path: "/contact" },
];

export const SERVICES = [
  {
    slug: "network-management",
    title: "Network Management",
    short: "Routers, switches & seamless connectivity for uninterrupted operations.",
    icon: "Network",
    points: [
      "Cisco / Juniper router configuration",
      "Layer 2 / Layer 3 switch deployment",
      "VLAN, Routing, ACL & QoS setup",
      "Firewall, VPN & site-to-site connectivity",
      "24/7 network monitoring & incident response",
    ],
  },
  {
    slug: "infrastructure-support",
    title: "Infrastructure Support",
    short: "Servers, storage and data-center systems engineered for uptime.",
    icon: "ServerCog",
    points: [
      "Rack, blade & tower server deployment",
      "SAN / NAS storage configuration",
      "RAID, backup & disaster recovery",
      "OS hardening & patch management",
      "On-site & remote field engineering",
    ],
  },
  {
    slug: "virtualization",
    title: "Virtualization",
    short: "VMware vSphere, vCenter, Horizon & Workstation expertise.",
    icon: "Layers",
    points: [
      "VMware vSphere ESXi installation & tuning",
      "vCenter Server cluster management",
      "VMware Horizon VDI deployment",
      "VMware Workstation pro support",
      "P2V / V2V migrations & capacity planning",
    ],
  },
  {
    slug: "microsoft-ecosystem",
    title: "Microsoft Ecosystem",
    short: "Windows Server, Azure, Hyper-V, AD, SQL & Deployment Imaging.",
    icon: "Boxes",
    points: [
      "Windows Server 2016/2019/2022 administration",
      "Microsoft Azure cloud workloads",
      "Hyper-V virtualization & failover clustering",
      "Active Directory, GPO, DNS & DHCP",
      "SQL Server, MDT/SCCM imaging & deployment",
    ],
  },
];

export const INDUSTRIES = [
  { name: "Banking & Finance", icon: "Landmark" },
  { name: "Healthcare", icon: "HeartPulse" },
  { name: "Manufacturing", icon: "Factory" },
  { name: "Retail & E-commerce", icon: "ShoppingBag" },
  { name: "Education", icon: "GraduationCap" },
  { name: "Logistics", icon: "Truck" },
  { name: "Media & Telecom", icon: "Radio" },
  { name: "Government", icon: "Building2" },
];

export const TESTIMONIALS = [
  {
    quote:
      "R-Tech's engineers became an extension of our IT team. Their 24/7 response on our data-center incidents is unmatched.",
    name: "Rohit Sharma",
    role: "IT Head, BFSI Enterprise",
  },
  {
    quote:
      "From VMware migrations to AD restructuring, their team executed flawlessly across our 18 branch offices.",
    name: "Priya Iyer",
    role: "Infrastructure Manager, Retail Group",
  },
  {
    quote:
      "Skilled, punctual and professional — exactly the kind of on-ground manpower we needed in tier-2 cities.",
    name: "Anil Verma",
    role: "VP Operations, Logistics Co.",
  },
];

export const STATS = [
  { value: "24/7", label: "Support Availability" },
  { value: "100+", label: "Skilled Engineers" },
  { value: "Pan-India", label: "Service Footprint" },
  { value: "<30 min", label: "Avg. Response Time" },
];

export const WHY_CHOOSE = [
  {
    icon: "Clock",
    title: "Round-the-Clock Support",
    desc: "Always-on incident response, monitoring and on-call engineering — every day of the year.",
  },
  {
    icon: "MapPin",
    title: "Pan-India Presence",
    desc: "On-ground engineers across major Indian cities for seamless field deployment & SLA delivery.",
  },
  {
    icon: "Users",
    title: "Skilled Engineers",
    desc: "Certified specialists in VMware, Microsoft, Cisco and storage platforms with deep enterprise experience.",
  },
  {
    icon: "ShieldCheck",
    title: "Enterprise-Grade SLAs",
    desc: "Transparent SLAs with measurable uptime, response & resolution commitments tailored to your business.",
  },
];

export const OPEN_ROLES = [
  { title: "Network Engineer (L2/L3)", location: "Mumbai", type: "Full-time" },
  { title: "VMware Virtualization Specialist", location: "Pan-India", type: "Full-time" },
  { title: "Windows / AD Administrator", location: "Mumbai / Pune", type: "Full-time" },
  { title: "Field Service Engineer", location: "Delhi NCR / Bengaluru", type: "Full-time" },
  { title: "SQL Database Administrator", location: "Remote / Mumbai", type: "Full-time" },
];
